import { PLATFORM as SUPERMETRICS_PLATFORM, type SupermetricsPlatform } from 'shared/thirdParty/supermetrics'

export const isSupermetricsPlatform = (platform: string): platform is SupermetricsPlatform => {
  const supermetricsPlatforms = Object.values<string>(SUPERMETRICS_PLATFORM)
  return supermetricsPlatforms.includes(platform)
}
